import {
  SPWebHooksCreate,
  SPWebHooksEdit,
  SPWebHooksList,
  SPWebHooksShow,
} from "../sp_webhooks";

export const OrgSPWebHooksCreate = (props) => {
  return <SPWebHooksCreate {...props} />;
};

export const OrgSPWebHooksList = (props) => (
  <SPWebHooksList title="My Webhooks" {...props} />
);

export const OrgSPWebHooksEdit = (props) => {
  return <SPWebHooksEdit columns={1} {...props} />;
};

export const OrgSPWebHooksShow = (props) => {
  return <SPWebHooksShow {...props} />;
};
